<template>
  <b-card :img-src="img" img-alt="Image" img-top tag="article" class="mb-2">
    <b-card-title class="text-center">
      <span class="h1"> {{ title }} </span>

      <hr style="border: none; border-top: 1px solid #ff9f43" />
    </b-card-title>
    <b-card-text>
      <div class="d-flex justify-content-around">
        <div class="d-flex w-50 pt-2 justify-content-center">
          <div class="text-center">
            <div class="h2 text-center" cols="12">{{ rightNumber }}</div>
            <div class="h4 text-center" cols="12">{{ rightText }}</div>
          </div>
        </div>

        <hr
          style="
            border: none;
            border-left: 1px solid rgb(235, 233, 241);
            height: 80px;
            width: 1px;
          "
        />
        <div class="d-flex w-50 pt-2 justify-content-center">
          <div class="text-center">
            <div class="h2 text-center" cols="12">{{ leftNumber }}</div>
            <div class="h4 text-center" cols="12">{{ leftText }}</div>
          </div>
        </div>
      </div>
    </b-card-text>
  </b-card>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BCardImg,
  BCardTitle,
  BMedia,
  BMediaAside,
  BCardText,
} from "bootstrap-vue";
export default {
  components: {
    BCard,
    BRow,
    BCol,
    BCardImg,
    BCardTitle,
    BMedia,
    BMediaAside,
    BCardText,
  },
  props: ["title", "rightNumber", "rightText", "leftNumber", "leftText", "img"],
};
</script>
